
import { useState } from "react";
import "../styles/About.css";


const HoverCards = () => {
  return (
    <section className="A_sec5_bottom">
      <section className="A_sec5_bottom_left">
        <HoverImage
          src="images/A_sec5_n_img1.png"
          title="People"
          description="At the heart of everything we do, our people are our greatest asset. We believe in creating a supportive environment where both our employees and clients thrive."
        />
      </section>
      <section className="A_sec5_bottom_right">
        <HoverImage
          src="images/A_sec5_n_img2.png"
          title="Technology"
          description="We are committed to staying at the forefront of technological advancements, which allows us to continuously provide our clients with innovative tools and strategies."
        />
        <HoverImage
          src="images/A_sec5_n_img3.png"
          title="Innovation"
          description="We embrace creativity, encourage new ideas, and are always exploring ways to push boundaries and solve challenges in unique and meaningful ways."
        />
      </section>
    </section>
  );
};

const HoverImage = ({ src, title, description }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="hover-container"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <img className="hover-image" src={src} alt={title} />
      <div className={`hover-text ${hovered ? "visible" : ""}`}>
        <h3 className="hover_text_header">{title}</h3>
        <p className="hover_text_text">{description}</p>
      </div>
    </div>
  );
};

export default HoverCards;
